import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Audio({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-2.5 -4.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g
        className={theme.stroke}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M7.71453333 9.59546818H1.5072V21.4742636h6.20733333l11.26799997 8.4218637V1.17426364zM22.1061333 21.564625c3.3713334-3.3330227 3.3713334-8.7263636 0-12.05938636M24.9814667 25.0873341c5.3406666-5.2799773 5.3406666-13.8250909 0-19.10506819M28.5572667 29.3675364c7.7333333-7.6461137 7.7333333-20.01922731 0-27.66534094" />
      </g>
    </svg>
  )
}

Audio.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
